module.exports = __webpack_public_path__ + "static/media/AC08004D_03.477a99e1.png";